export const GTM_CONTAINER_IDS = {
  genesisPages: {
    containerId: 'GTM-KCFBZRL',
    htmlTagId: 'gtm-script-genesis-pages',
  },
};
